import { createContext, useState } from "react";

export const UserContext = createContext();

export const SearchContext = createContext();
